module.exports = __webpack_public_path__ + "static/img/hover4.3d876439.png";